import ExpandableTable from "react-exp-table/dist/src/ExpandableTable";

export default ExpandableTable;
